import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimEmailTemplate.List.IRequest;
type Response = Api.Core.ClaimEmailTemplate.List.IResponse;
type Headers = Api.Core.ClaimEmailTemplate.List.IHeaders;
const url = '/api/Management/ClaimEmailTemplate';
export default async function claimEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
